import React, { useState, useMemo, useEffect } from "react";
import "./GenericContainer.css";

const GenericContainer = ({ children }) => {
  const [activeSectionId, setActiveSectionId] = useState(children[0]?.props?.id);

  useEffect(() => {
    // Reset activeSectionId if children change
    if (!children.some((child) => child.props.id === activeSectionId)) {
      setActiveSectionId(children[0]?.props?.id);
    }
  }, [children, activeSectionId]);

  const navigateToSection = (sectionId) => {
    const sectionExists = children.some((child) => child.props.id === sectionId);
    if (sectionExists) {
      setActiveSectionId(sectionId);
    } else {
      console.error(`Section with id "${sectionId}" not found.`);
    }
  };

  const activeSection = useMemo(
    () => children.find((child) => child.props.id === activeSectionId),
    [activeSectionId, children]
  );

  if (!activeSection) {
    return <div>No section available to display.</div>;
  }

  return (
    <div className="generic-container">
      {React.cloneElement(activeSection, { navigateToSection })}
    </div>
  );
};

export default GenericContainer;
